import { aiColors, tint } from '@euler/app/flows/ai-suite/theme';
import AccidentAndInsuranceSvg from '@euler/assets/coaching-collections/accident_and_insurance.svg';
import ComplianceAndBoundariesSvg from '@euler/assets/coaching-collections/compliance_and_boundaries.svg';
import DeliveryAndAftercareSvg from '@euler/assets/coaching-collections/delivery_and_aftercare.svg';
import EvFrontDeskSvg from '@euler/assets/coaching-collections/ev_front_desk.svg';
import EvidenceAndOldPartsSvg from '@euler/assets/coaching-collections/evidence_and_old_parts.svg';
import ExplainInspectionFindingsSvg from '@euler/assets/coaching-collections/explain_inspection_findings.svg';
import FirstWeekAtReceptionSvg from '@euler/assets/coaching-collections/first_week_at_reception.svg';
import HandleDifficultMomentsSvg from '@euler/assets/coaching-collections/handle_difficult_moments.svg';
import KeepCustomersReturningSvg from '@euler/assets/coaching-collections/keep_customers_returning.svg';
import NewCustomerFirstVisitSvg from '@euler/assets/coaching-collections/new_customer_first_visit.svg';
import PriceObjectionsAndNegotiationSvg from '@euler/assets/coaching-collections/price_objections_and_negotiation.svg';
import QuoteAndAdditionalWorkSvg from '@euler/assets/coaching-collections/quote_and_additional_work.svg';
import RefusalAndWinBackSvg from '@euler/assets/coaching-collections/refusal_and_win_back.svg';
import SellPackagesResponsiblySvg from '@euler/assets/coaching-collections/sell_packages_responsibly.svg';
import WarrantyAndThreeGuaranteesSvg from '@euler/assets/coaching-collections/warranty_and_three_guarantees.svg';
import { Layers } from 'lucide-react-native';
import { FC, memo } from 'react';
import { View } from 'react-native';
import { SvgProps } from 'react-native-svg';

/** The system collections' illustrations, by collection slug. */
const kIllustrations: Record<string, FC<SvgProps>> = {
  accident_and_insurance: AccidentAndInsuranceSvg,
  compliance_and_boundaries: ComplianceAndBoundariesSvg,
  delivery_and_aftercare: DeliveryAndAftercareSvg,
  ev_front_desk: EvFrontDeskSvg,
  evidence_and_old_parts: EvidenceAndOldPartsSvg,
  explain_inspection_findings: ExplainInspectionFindingsSvg,
  first_week_at_reception: FirstWeekAtReceptionSvg,
  handle_difficult_moments: HandleDifficultMomentsSvg,
  keep_customers_returning: KeepCustomersReturningSvg,
  new_customer_first_visit: NewCustomerFirstVisitSvg,
  price_objections_and_negotiation: PriceObjectionsAndNegotiationSvg,
  quote_and_additional_work: QuoteAndAdditionalWorkSvg,
  refusal_and_win_back: RefusalAndWinBackSvg,
  sell_packages_responsibly: SellPackagesResponsiblySvg,
  warranty_and_three_guarantees: WarrantyAndThreeGuaranteesSvg,
};

/**
 * A collection's square illustration, which brings its own rounded tile;
 * a collection without one gets a plain tile.
 */
export const CollectionIllustration = memo(
  ({ slug, size }: { slug: string; size: number }) => {
    const Illustration = kIllustrations[slug];
    if (Illustration) return <Illustration width={size} height={size} />;
    return (
      <View
        style={{
          width: size,
          height: size,
          borderRadius: size * 0.23,
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: tint(aiColors.primary, 0.1),
        }}
      >
        <Layers size={size * 0.4} color={aiColors.primary} />
      </View>
    );
  },
);
